import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './allEvents.css'
import ItemsCarousel from 'react-items-carousel';
import './allEvents.css';
import potter from '../../images/potter.png';
import festival from '../../images/festival.png';
import eleves from '../../images/eleves.png';
import foot from '../../images/foot.png';
import prix from '../../images/prix.png';
import { useHistory } from 'react-router-dom';
import ModalImage from '../modalImage/ModalImage';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'


const AllEvents = () => {



const [event, setEvent] = useState({
  url: null
})
const [archives, setArchives] = useState([])
const [image, setImage] = useState([])
let history = useHistory()

const popupaddpic = () => {
  Swal.fire({
      position: 'center',
      icon: 'success',
      title: `Ta photo à bien été ajouté attend qu'elle soit validée !`,
      showConfirmButton: true,
     
  })
}

useEffect (() => {
    fetchdata()
    fetchimage()
},[])

useEffect (() => {
  axios.post('https://clean-my-calanques.herokuapp.com/newgalerie', event)
  .then(x => popupaddpic())
},[event])



const fetchimage = () => {
    axios.get('https://clean-my-calanques.herokuapp.com/picgalerie')
    .then(response => setImage(response.data))
    .then(history.push('/allEvents'))
    .catch(err => console.log(err))
}

const fetchdata = () => {
  axios.get('https://clean-my-calanques.herokuapp.com/events/archives')
  .then(response => setArchives(response.data))
  .catch(err => console.log(err))
  console.log(archives)
}

const [activeItemIndex, setActiveItemIndex] = useState(0);
const chevronWidth = 50;


return (
    <div className='allEvents'>
      <div className='allCarousel' style={{ padding: `0 ${chevronWidth}px` }}>
      <div className = "bonus"> Nos exploits </div>
    <ItemsCarousel
    requestToChangeActive={setActiveItemIndex}
    activeItemIndex={activeItemIndex}
    numberOfCards={1}
    gutter={100}
    infiniteLoop={true}
    leftChevron={<button className='chevronButton'>{'⇚'}</button>}
    rightChevron={<button className='chevronButton'>{'⇛'}</button>}
    outsideChevron
    chevronWidth={chevronWidth}
    >
     <img className="brochure" src={potter}  alt='potter'/>
     <img className="brochure" src={festival}  alt='festival'/>
     <img className="brochure" src={eleves}  alt='eleves'/>
     <img className="brochure" src={foot}  alt='foot'/>
     <img className="brochure" src={prix}  alt='prix'/>
  </ItemsCarousel>
</div>
 <ModalImage event={event} setEvent={setEvent} />

  
         <div className="mosa-hic">
            
             {image.map(e => {
                return <li> <img src={e.url} className="mosaic" alt="imageMap"/></li>
       
            })}

        </div>

</div>


    )
}
export default AllEvents;